import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DragIndicator from '@material-ui/icons/DragIndicator';

import { Checkbox } from '../../../components/material-ui/Checkbox';
import { Typography } from '../../../components/material-ui/Typography';
import { useStyles } from './useStyles';


export const PartitionSettingRow = memo(({ index, item, visible, onCheck }) => {
    const Icon = item?.icon;
    const label = item?.label;

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback((event) => onCheck(index, event.target.checked), [index]);

    return (
        <div>
            <div className={classes.div}>
                <DragIndicator width="24" height="24" className={classes.icon} />
            </div>
            <div className={classes.check}>
                <Checkbox checked={visible} onChange={handleClick} color="primary" />
            </div>
            <div className={classes.div}>
                <Icon width="24" height="24" className={classes.icon} />
            </div>
            <div className={classes.div}>
                <Typography>{translate(label)}</Typography>
            </div>
        </div>
    );
});

PartitionSettingRow.displayName = 'PartitionSettingRow';
